import produce from 'immer';

import { FETCH_POLICIES_SUCCEEDED, UPDATE_POLICIES, LOGOUT } from '../../constants/actionTypes';

const initState = {};

export default produce((draft, action) => {
  switch (action.type) {
    case FETCH_POLICIES_SUCCEEDED: {
      return action.payload.entities.policies;
    }

    case UPDATE_POLICIES: {
      if (Array.isArray(action.payload)) {
        action.payload.forEach((policy) => {
          if (draft[policy.id]) {
            draft[policy.id].accept = policy.accept;
          }
        });
      }
      break;
    }

    case LOGOUT: {
      return initState;
    }
  }
}, initState);
